import { useState, useEffect } from 'react';
import { Check, Zap, Crown } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

function getPlans(monthlyPrice, annualPrice, registeredMonthlyPrice) {
  return [
    {
      name: 'Gratis',
      price: '$0',
      period: '',
      icon: Check,
      iconColor: 'text-slate-500',
      features: [
        '3 consultas IA/mes',
        '1 benchmark/mes',
        '2 cálculos de liquidación',
        '2 evaluaciones de oferta',
        '2 cálculos de sueldo neto',
      ],
    },
    {
      name: 'Pro Mensual',
      price: `$${monthlyPrice}`,
      period: 'MXN/mes',
      icon: Zap,
      iconColor: 'text-[#2563EB]',
      highlight: true,
      features: [
        'Todo ilimitado',
        'Asesor IA con memoria contextual',
        `$${registeredMonthlyPrice}/mes si ya tienes cuenta`,
      ],
    },
    {
      name: 'Pro Anual',
      price: `$${annualPrice}`,
      period: 'MXN/año',
      icon: Crown,
      iconColor: 'text-amber-500',
      features: [
        'Todo lo de Pro Mensual',
        'Mejor valor',
        'Acceso completo todo el año',
      ],
    },
  ];
}

export function PlanInfoCards() {
  const [monthlyPrice, setMonthlyPrice] = useState(129);
  const [annualPrice, setAnnualPrice] = useState(990);
  const [registeredMonthlyPrice, setRegisteredMonthlyPrice] = useState(119);

  useEffect(() => {
    const fetchPricing = async () => {
      try {
        const headers = {};
        const token = localStorage.getItem('token');
        if (token) headers['Authorization'] = `Bearer ${token}`;
        const res = await fetch(`${API_URL}/api/pricing/info`, { headers });
        if (res.ok) {
          const data = await res.json();
          setMonthlyPrice(data.monthly_price);
          setAnnualPrice(data.annual_price);
          setRegisteredMonthlyPrice(data.registered_monthly_price);
        }
      } catch {}
    };
    fetchPricing();
  }, []);

  const plans = getPlans(monthlyPrice, annualPrice, registeredMonthlyPrice);

  return (
    <div className="mt-8" data-testid="plan-info-cards">
      <p className="text-center text-xs text-muted-foreground mb-3">Planes disponibles</p>
      <div className="grid grid-cols-3 gap-2">
        {plans.map((plan) => {
          const Icon = plan.icon;
          return (
            <div
              key={plan.name}
              className={`rounded-lg p-3 text-center ${
                plan.highlight
                  ? 'bg-[#2563EB]/5 border border-[#2563EB]/20'
                  : 'bg-muted/50 border border-transparent'
              }`}
            >
              <Icon className={`w-4 h-4 mx-auto mb-1 ${plan.iconColor}`} />
              <p className="text-xs font-semibold text-[#0F172A]">{plan.name}</p>
              <p className="text-sm font-bold text-[#0F172A] mt-0.5">
                {plan.price}
                {plan.period && <span className="text-[10px] font-normal text-muted-foreground"> {plan.period}</span>}
              </p>
              <ul className="mt-1.5 space-y-0.5">
                {plan.features.map((f) => (
                  <li key={f} className="text-[10px] text-muted-foreground leading-tight">{f}</li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    </div>
  );
}
